import React from "react";
import PieChart from "../../../components/singleComponenets/PieChart";

const PieChartsRow = ({
  title,
  hasOptions = false,
  optionsArr = [],
  pieData = [],
  loading = false,
  text,
  getTotalForSite = null,
}) => {
  if (loading) {
    return (
      <div className="text-white">
        <span className="text-xl font-bold">{title}</span>
        <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />
        <div className="text-gray-400">Loading...</div>
      </div>
    );
  }
  if (!pieData || pieData.length === 0) {
    return (
      <div className="text-white">
        <span className="text-xl font-bold">{title}</span>
        <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />
        <div className="text-gray-400">No data available</div>
      </div>
    );
  }

  return (
    <div className="text-white">
      <div className="flex justify-between">
        <span className="text-xl font-bold">{title}</span>
        {hasOptions && (
          <div className="flex gap-4 mt-4 text-sm">
            {optionsArr.map((option) => (
              <div className="flex items-center gap-2" key={option.value}>
                <span
                  className="w-3 h-3 block rounded-full"
                  style={{ backgroundColor: option.color }}
                />
                {option.value}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="w-full bg-[#2E2E2E] my-5 h-0.5" />

      <div className="grid md:grid-cols-3 gap-10">
        {pieData.map((data, i) => {
          const externalTotal = getTotalForSite ? getTotalForSite(data.siteName) : null;
          return (
            <PieChart 
              key={i} 
              data={data} 
              text={text} 
              externalTotal={externalTotal}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PieChartsRow;
